import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Es para profesores o para principiantes?',
  a: 'Es un sistema práctico pensado para docentes y entrenadores que ya trabajan con gimnasia artística pero quieren organizar mejor sus sesiones y seguimiento.'
}, {
  q: 'Tengo grupos con niveles mezclados. ¿Me sirve?',
  a: 'Totalmente. Es uno de los pilares del ProfePack: darte herramientas para que diferentes niveles convivan y progresen en la misma clase.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'El acceso es inmediato. Una vez realizado el pago, recibes un correo con el link de descarga de los 6 volúmenes y sus 5 bonos en formato PDF de alta calidad.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-30">
            Dudas
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy" data-id="element-31">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className={`bg-white rounded-2xl border transition-colors ${isOpen ? 'border-primary/30 shadow-md' : 'border-gray-200'}`} data-id="element-33">
                <button onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-34">
                  <span className={`font-bold pr-4 ${isOpen ? 'text-primary' : 'text-navy'}`} data-id="element-35">
                    {faq.q}
                  </span>
                  <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-primary/10 text-primary' : 'bg-gray-50 text-gray-400'}`} data-id="element-36">
                    {isOpen ? <Minus className="w-4 h-4" data-id="element-37" /> : <Plus className="w-4 h-4" data-id="element-38" />}
                  </div>
                </button>
                <AnimatePresence data-id="element-39">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-40">
                      <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-50 mt-2" data-id="element-41">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}